import React from 'react';
import { BookOpenIcon, ShieldCheckIcon } from 'lucide-react';
import { mockupUrl, offerAnchor } from '../data/content';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function Hero() {
  return <section className="bg-blue-950 pb-14 md:pb-16" data-id="element-95" data-mp="9lbfqzxtf9d2">
      <div className="border-b border-white/10 px-4 py-2.5 text-center" data-id="element-96" data-mp="4m8nkg2xoxmi">
        <p className="text-[11px] font-extrabold uppercase tracking-[.3em] text-sky-300 md:text-xs" data-id="element-97" data-mp="4jvx1ej41exu">
          Bright Digital Hub
        </p>
      </div>
      <div className="mx-auto max-w-4xl px-4 pt-8 text-center md:pt-10" data-id="element-98" data-mp="xbfi73z9p32h">
        <h1 className="mx-auto max-w-3xl font-black uppercase leading-tight tracking-tight text-white" data-id="element-99" data-mp="saruar6c52ch">
          <span className="block text-sm md:text-lg" data-id="element-100" data-mp="nczsn5fw21v3">The complete ready-to-use sports massage system for professionals</span>
          <span className="mt-2 block text-3xl sm:text-4xl md:text-6xl md:leading-[1.02]" data-id="element-101" data-mp="3d2birmcv0tty">
            Complete <span className="text-sky-300" data-id="element-102" data-mp="381nrczkpyaz7">Sports Massage</span> Bundle
          </span>
        </h1>

        <OfferLink className="mx-auto my-8 max-w-[320px] sm:max-w-[440px]" label="See the Complete Sports Massage Bundle offer" data-id="element-103" data-mp="3j9ty8ric7ai4">
          <img src={mockupUrl} alt="Complete Sports Massage Bundle: 5 complete volumes and 5 practical bonuses" className="w-full rounded-2xl bg-white object-contain p-3 shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-104" data-mp="3o59d9ms2zcg4" />
        </OfferLink>

        <p className="mx-auto max-w-2xl text-base font-bold leading-relaxed text-white md:text-lg" data-id="element-105" data-mp="358hleoyh3p0g">
          Professional protocols, step-by-step techniques, complete sports massage sessions, and practical client
          management tools — all organized in one system.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-white/80 md:text-base" data-id="element-106" data-mp="2vglld8cttotl">
          Access practical resources for lower-body and upper-body sports massage, pre-event and post-event sessions,
          maintenance work, and complete treatment sessions organized by sport.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-sm leading-relaxed text-white/70" data-id="element-107" data-mp="nbbeh30z0j7e">
          With clear techniques, client positioning, session durations, practical adaptations, and professional
          reference tools.
        </p>
        <p className="mt-5 text-xs font-black uppercase tracking-wider text-white md:text-sm" data-id="element-108" data-mp="de6oes4083lb">
          Less time organizing. <span className="text-sky-300" data-id="element-109" data-mp="1b0drtyoknpw3">More clarity in every session.</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-xs font-bold uppercase tracking-wide text-yellow-300 md:text-sm" data-id="element-110" data-mp="16346au4azydj">
          Complete Sports Massage Bundle: 5 Complete Volumes + 5 Practical Bonuses
        </p>

        <div className="mt-7" data-id="element-111" data-mp="x0l48c8cdpsc">
          <Button href={offerAnchor} size="lg" subtext="Get instant digital access today" data-id="element-112" data-mp="x3h1dycd8afq">
            Yes! I want the complete system
          </Button>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-bold uppercase tracking-wide text-white/80" data-id="element-113" data-mp="3hpsf16g55t2k">
          <li className="flex items-center gap-1.5" data-id="element-114" data-mp="21awco6qesnfd">
            <ShieldCheckIcon className="h-4 w-4 text-sky-300" aria-hidden="true" data-id="element-115" data-mp="21bpnpjwehz3b" /> 7-Day Guarantee
          </li>
          <li className="flex items-center gap-1.5" data-id="element-116" data-mp="268oeptkrppxa">
            <BookOpenIcon className="h-4 w-4 text-sky-300" aria-hidden="true" data-id="element-117" data-mp="2b198iv3oc30t" /> 5 Complete Volumes + 5 Practical Bonuses
          </li>
        </ul>
      </div>
    </section>;
}